<template>
  <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm" novalidate>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-slider"></i>
                <h2 class="card-big-info-title">Područje primjene</h2>
              </div>

              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.area.title.$invalid && $v.$dirty }">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv prostora</label>
                  <div class="col-lg-7 col-xl-6">
                    <input type="text" class="form-control form-control-modern" placeholder="Naziv prostora" v-model="area.title"/>

                    <form-error :model="$v.area.title" :dirty="$v.$dirty" label="Naziv prostora" />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.area.description.$invalid && $v.$dirty }">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis prostora</label>
                  <div class="col-lg-7 col-xl-6">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="area.description"
                      placeholder="Opis prostora"
                    ></textarea>

                    <form-error :model="$v.area.description" :dirty="$v.$dirty" label="Opis prostora" />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Nadredjeni prostor</label>
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="area.parentCleaningAreaId"
                      :multiple="false"
                      :options="areas"
                      :show-count="true"
                      placeholder="Izaberite prostoriju"
                      v-if="areas"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3">
                  <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Ikona</label>
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="file"
                      class="form-control form-control-modern"
                      ref="icon"
                      @change="handlePhotoUpload"
                      accept="image/*"
                      :disabled="!area.parentCleaningAreaId"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="action-buttons d-flex justify-content-between" style="margin-top: 2rem">
      <div>
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#delete-modal"
          class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
        </button>
      </div>
      <div class="d-flex gap-3">
        <router-link exact :to="{ name: 'CleaningAreas' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
          {{ translations.cancel }}
        </router-link>
        <button
          type="submit"
          class="
            submit-button
            btn btn-primary btn-px-4
            py-3 d-flex align-items-center
            font-weight-semibold line-height-1
          "
        >
          <i class="bx bx-save text-4 me-2"></i>{{ translations.save }}
        </button>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header">
        <strong>Izbriši područje primjene</strong>
      </h5>
      <div slot="body">
        Jeste li sigurni da želite izbrisati područje primjene?
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="deleteCleaningAreas"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </form>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import api from '@/services/api';
import validations from './validation-schema/add';
import FormError from '@/components/shared/form-errors/FormError.vue';
import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'EditCleaningArea',
  components: { FormError, Treeselect, Modal },
  mixins: [translations],
  validations: {
    area: validations
  },
  computed: {
    area() {
      return this.$store.getters.getCleaningArea;
    },
    areas() {
      return this.$store.getters.getCleaningAreas.map(({ title, id }) => ({
        label: title,
        id,
      }));
    },
  },
  data() {
    return {
      title: '',
      description: '',
      parentCleaningAreaId: null,
      icon: '',
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      const { area } = this;

      if (!this.$v.$invalid) {
        api.updateCleaningArea(area).then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CleaningAreas' });
        }).catch((err) => {
          this.$toast.error(err.response.data.info);
        });
      } else {
        this.$toast.error(this.translations.forms.notValid);
      }
    },
    handlePhotoUpload() {
      const file = this.$refs.icon.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      reader.onload = (e) => {
        this.area.icon = e.target.result.split(',')[1];
      };
    },
    deleteCleaningAreas() {
      api
        .deleteCleaningAreas(this.area.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: "CleaningAreas" });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
  mounted() {
    this.$store.dispatch('getCleaningAreas', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
      retrieveOnlyParents: true
    });
    this.$store.dispatch('getCleaningAreaById', this.$route.params.id);
  },
}
</script>